import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { QueryClient } from '@tanstack/react-query'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'
import { Toaster } from '@/components/ui/sonner'
import { ThemeProvider } from '@/components/providers/theme-provider'
import { WorkOSAuthProvider } from '@/components/providers/workos-auth-provider'
import { AuthProvider } from '@/contexts/auth-context'
import { BaseCurrencyProvider } from '@/contexts/base-currency-context'

interface RouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
})

function RootLayout() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="wealthscale-theme">
      <WorkOSAuthProvider>
        <AuthProvider>
          <BaseCurrencyProvider>
            <Outlet />
            <Toaster />
            {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
          </BaseCurrencyProvider>
        </AuthProvider>
      </WorkOSAuthProvider>
    </ThemeProvider>
  )
}
